import React  from 'react';
import 'Styles/errorWindow.scss';
import { observer } from "mobx-react";
import { Navigate } from "react-router-dom";

const ErrorWindow = (props) => {
    if (props.smrWorkState.doesSmrWork)
        return <Navigate to={ `${ window.SmrLocation }/login` }/>

    let description = '';

    switch (props.smrWorkState.stopReason) {
        case 1:
            description = "Ошибка инициализации логирования";
            break;
        case 2:
            description = "Ошибка подключения к базе данных";
            break;
        case 3:
            description = "Устаревшая версия базы данных";
            break;
        case 4:
            description = "Ошибка миграции базы данных";
            break;
        case 5:
            description = "Файловое хранилище недоступно";
            break;
        case 6:
            description = "Недостаточно свободного места в файловом хранилище";
            break;
        default:
            description = "Неизвестная причина";
    }

    return (
        <div className='error-window'>
            <div className='error-window-error-holder'>
                <div className='error-header'>
                    <div>
                        Сервер мобильных решений
                    </div>
                    <div>
                        Версия: { props.version }
                    </div>
                </div>
                <div className='error-content'>
                    <div className='wall'/>
                    <div className='floor'/>
                    <div className='it'/>
                    <div className='error-description'>
                        <div className='title'>СМР не запущен!</div>
                        <div className='description'>{ description }</div>
                    </div>
                    <div className='tech-description-container'>
                        <div
                            className='error-tech-description overflowing-element'>{ props.smrWorkState.techDescription } </div>
                    </div>
                    {
                        props.smrWorkState.exception != null ?
                            <button className='blue-button'
                                    onClick={ props.printSmrStartError }>
                                Выгрузить
                            </button>
                            : ''
                    }
                </div>
            </div>
        </div>
    )
}

export default observer(ErrorWindow);